<template>
  <div class="containerMarcaE">
    <div v-if="loading" class="text-center">
      <v-progress-circular
        class="mt-auto"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="mt-5 col-sm-8 col-md-12 mx-auto"
      >
        <div class="grid-container col-md-10 mx-auto">
          <div class="item1">
            <span class="text-welcome">*Título de Bienvenida</span>
            <v-text-field
              outlined
              color="secondary"
              required
              :rules="rules"
              :counter="40"
              :maxlength="40"
              v-model="dataWelcome.welcomeTitle"
              placeholder="Título"
            >
            </v-text-field>
          </div>

          <div class="item2">
            <span class="text-welcome">*Texto de Bienvenida</span>
            <v-textarea
              outlined
              color="secondary"
              required
              :rules="rules"
              :counter="200"
              :maxlength="200"
              v-model="dataWelcome.welcomeBody"
              placeholder="Texto"
            >
            </v-textarea>
          </div>

          <div class="item3">
            <span class="text-welcome">Imagen de Bienvenida:</span>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="btn-add-image"
                  fab
                  bottom
                  dark
                  small
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <label for="file-input">
                    <v-icon dark>mdi-plus</v-icon>
                  </label>
                </v-btn>
              </template>
              <span>Seleccionar una Imagen</span>
              <!-- Input de tipo archivo oculto -->
              <input
                type="file"
                @change="onFileChange"
                id="file-input"
                accept="image/*"
                style="display: none"
              />
            </v-tooltip>
          </div>
          <div class="item4 mobile-view">
            <div v-if="dataWelcome.welcomeImageUrl" class="image-square">
              <!-- Muestra imagen seleccionada -->
              <img
                v-if="
                  allowedImageTypes.includes(
                    dataWelcome.welcomeImageUrl.type
                  )
                "
                :src="generateImageUrlPreview(dataWelcome.welcomeImageUrl)"
                alt="Imagen cargada"
              />

              <!-- Muestra imagen si lo trae el servicio -->
              <img
                v-else
                :src="dataWelcome.welcomeImageUrl"
                alt="Imagen cargada"
              />
            </div>
            <!-- Muestra imagen si NO lo trae el servicio -->
            <div v-else class="image-square">
              <p>Aquí visualizas la imagen seleccionada</p>
              <!--<img src="https://beneflex-icons.s3.amazonaws.com/clients/lucasianlabs.svg" alt="Imagen cargada" /> -->
            </div>
            <br />
            <div class="mobile-text">
              <h3>{{ dataWelcome.welcomeTitle }}</h3>
              <p>{{ dataWelcome.welcomeBody }}</p>
            </div>
          </div>
        </div>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!valid"
              fab
              fixed
              bottom
              right
              dark
              Large
              color="primary"
              @click="validate()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>mdi-content-save</v-icon>
            </v-btn>
          </template>
          <span>Guardar Marca Empresarial</span>
        </v-tooltip>
      </v-form>
    </div>
  </div>
</template>

<script>
import {
  WELCOME_M,
  GET_WELCOME,
  GET_MARCA,
  GET_STATE_LOADING_MARCA,
  ACTION_CREATE_MARCAEMPRESARIAL,
  ACTION_UPDATE_MARCAEMPRESARIAL,
} from "@/views/home/store/types/types.js";

import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      valid: true,
      allowedImageTypes: [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/svg+xml",
      ],
      rules: [value => !!value || "Campo requerido.", ],
    };
  },
  computed: {
    ...mapGetters({
      dataWelcome: [`${WELCOME_M}${GET_WELCOME}`],
      dataMarca: [`${WELCOME_M}${GET_MARCA}`],
      loading: `${WELCOME_M}${GET_STATE_LOADING_MARCA}`,
    }),
  },
  methods: {
    ...mapActions({
      actionCreateMarca: `${WELCOME_M}${ACTION_CREATE_MARCAEMPRESARIAL}`,
      actionUpdateMarca: `${WELCOME_M}${ACTION_UPDATE_MARCAEMPRESARIAL}`,
    }),
    mounted() {
      if (this.dataMarca) {
        this.dataWelcome.welcomeTitle = this.dataMarca.welcomeTitle;
        this.dataWelcome.welcomeBody = this.dataMarca.welcomeBody;
        this.dataWelcome.welcomeImageUrl = this.dataMarca.welcomeImageUrl;
        this.dataWelcome.hasBusinessBranding = this.dataMarca.hasBusinessBranding;
      }
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.dataWelcome.welcomeImageUrl = file;
      }
      if (
        !this.allowedImageTypes.includes(
          this.dataWelcome.welcomeImageUrl.type
        )
      ) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor ingrese una imagen valida con formato jpg, png, jpeg, svg",
        });
      }
    },
    generateImageUrlPreview(file) {
      const preview = URL.createObjectURL(file);
      return preview;
    },
    validate() {
      if (!this.$refs.form.validate()) {
        return Swal.fire({
          icon: "error",
          title: "Error",
          text: "Debes diligenciar los campos",
          confirmButtonColor: '#6E17A5'
        });
      } else {
        if (this.dataWelcome.welcomeImageUrl == null) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "La imagen es requerida",
          });
        } else {
            this.dataWelcome.hasBusinessBranding
            ?  this.actionUpdateMarca(this.dataWelcome)
            :  this.actionCreateMarca(this.dataWelcome);
        }
      }
    },
  },
};
</script>

<style lang="css" scoped>
.text-welcome {
  color: #ff7900;
  margin-bottom: 30px;
}

.image-square img {
  max-width: 100%;
  max-height: 100%;
  border: none;
}

.grid-container {
  display: grid;
  gap: 20px;
}

.item4 {
  grid-row: 4/1;
  border: 5px solid #333;
}

.item3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-row: 3/3;
}

.mobile-view {
  width: 300px;
  background: #ff790010;
  border-radius: 15px;
  overflow: hidden;
  max-width: 360px;
  max-height: 550px;
  margin: 0 auto;
  padding: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}

.mobile-text,
h3 {
  color: #ff7900;
}

.mobile-text {
  font-family: "Amsi Pro", sans-serif;
  color: #0a0a0a;
  text-align: center;
}

p {
  text-align: center;
}

@media screen and (max-width: 799px) {
  .item1,
  .item3 {
    grid-row: unset;
    margin-top: 10px;
  }
}
</style>
